import axiosClient from ".";
class HighRollersAPI {
  static getHighRollers() {
    return axiosClient.get("/high_rollers.json");
  }
}
export default HighRollersAPI;
